'use client';

import { capitalize } from '@mcdougald/core';
import * as NavigationMenu from '@mcdougald/ui/src';
import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from '@mcdougald/ui/src';
import {
  BarChartIcon,
  FlameIcon,
  MessageCircleIcon,
  MonitorIcon,
  PencilIcon,
  X,
} from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Fragment } from 'react';
import {
  ContactNavigationMenuItem,
  ExperienceNavigationMenuItem,
  type HeaderNavLink,
  MoreNavigationMenuItem,
  PostsNavigationMenuItem,
  ProjectsNavigationMenuItem,
} from '@/components/layout/navbar/navigation-menu-items';
import { NavigationItemProps } from '@/components/layout/navbar/types';
import { HomeNavigationMenuItem } from '@/components/layout/navbar/home-navigation-menu-item';

const morePaths = ['/guestbook', '/about', '/resumes', '/dashboard'];

/**
 * Renders the page links
 */
export const HEADER_LINKS: HeaderNavLink[] = [
  {
    icon: <MessageCircleIcon className="size-3.5" />,
    href: '/',
    key: 'Home',
    isActive: (pathname: string) => pathname === '/',
    RenderNavItem: (props: NavigationItemProps) => (
      <HomeNavigationMenuItem {...props} />
    ),
  },
  {
    icon: <PencilIcon className="size-3.5" />,
    href: '/posts',
    key: 'Posts',
    isActive: (pathname: string) => {
      return pathname.startsWith('/posts/') || pathname === '/posts';
    },
    RenderNavItem: (props: NavigationItemProps) => (
      <PostsNavigationMenuItem {...props} />
    ),
  },
  {
    icon: <FlameIcon className="size-3.5" />,
    href: '/projects',
    key: 'Projects',
    isActive: (pathname: string) => {
      return pathname.startsWith('/projects/') || pathname === '/projects';
    },
    RenderNavItem: (props: NavigationItemProps) => (
      <ProjectsNavigationMenuItem {...props} />
    ),
  },
  {
    icon: <BarChartIcon className="size-3.5" />,
    href: '/contact',
    key: 'Contact',
    isActive: (pathname: string) => pathname === '/contact',
    RenderNavItem: (props: NavigationItemProps) => (
      <ContactNavigationMenuItem {...props} />
    ),
  },
  // {
  //   icon: <UserCircleIcon className="size-3.5" />,
  //   href: '/resumes',
  //   key: 'Resume',
  //   RenderNavItem: (props: NavigationItemProps) => (
  //     <ResumeNavigationMenuItem {...props} />
  //   ),
  // },
  {
    icon: <MonitorIcon className="size-3.5" />,
    href: '/experience',
    key: 'Experience',
    isActive: (pathname: string) => pathname === '/experience',
    RenderNavItem: (props: NavigationItemProps) => (
      <ExperienceNavigationMenuItem {...props} />
    ),
  },
  {
    icon: <MonitorIcon className="size-3.5" />,
    href: '/more',
    key: 'More',
    isActive: (pathname: string) => {
      return morePaths.some((path) => pathname.startsWith(path));
    },
    RenderNavItem: (props: NavigationItemProps) => (
      <MoreNavigationMenuItem {...props} />
    ),
  },
] as const;

const RenderMorePathname = (props: NavigationItemProps) => {
  return (
    <TooltipProvider>
      <TooltipRoot>
        <TooltipTrigger className={'w-0'}>
          <div className={'group flex items-center gap-2 text-gray-500'}>
            <Link
              href={'/'}
              className={'flex self-center ml-2 underline italic text-xs'}
            >
              {capitalize(props.pathname?.replaceAll('/', '') ?? '')}
            </Link>
            <X
              className={
                'opacity-30 group-hover:opacity-100 min-w-[12px] h-[12px] ml-[-2px]'
              }
              size={16}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent
          animation
          arrow={false}
          content={<p className="text-sm">{'Return Home'}</p>}
        />
      </TooltipRoot>
    </TooltipProvider>
  );
};

const Navbar = () => {
  const pathname = usePathname();

  const isMorePageActive = morePaths.some((path) => pathname.startsWith(path));

  console.log('[Navbar]', {
    pathname,
  });

  return (
    <nav className="navbar hidden md:block pr-21 lg:pr-21">
      <ul className="flex gap-2">
        <NavigationMenu.Root>
          <div className="hidden md:block items-center gap-4 text-sm lg:gap-6 flex flex-row">
            <NavigationMenu.List
              className={'flex [&_button]:px-2 [&_li>a]:px-2.5'}
            >
              <>
                {HEADER_LINKS.map((hLink) => {
                  const isActive = hLink.isActive(pathname);
                  return (
                    <Fragment key={hLink.key}>
                      <hLink.RenderNavItem
                        isActive={isActive}
                        pathname={pathname}
                      />
                      <>
                        {/*{isActive ? (*/}
                        {/*  <>*/}
                        {/*    <div className="bg-nav-link-indicator absolute bottom-0 left-1/2 h-px w-12 -translate-x-1/2" />*/}
                        {/*    <div className="absolute bottom-0 left-1/2 size-3.5 -translate-x-1/2 rounded-[4px] bg-[rgb(255_122_151)] blur-md dark:bg-[rgb(223_29_72)]" />*/}
                        {/*  </>*/}
                        {/*) : null}*/}
                      </>
                    </Fragment>
                  );
                })}
                {isMorePageActive ? (
                  <RenderMorePathname pathname={pathname} />
                ) : null}
              </>
            </NavigationMenu.List>
          </div>
        </NavigationMenu.Root>
      </ul>
    </nav>
  );
};

export default Navbar;
